import React, { useState } from 'react';
import classes from './VoiceRecorderModal.module.css';
import Modal from '../../../components/UI/Modals/Modal';
import { VoiceRecorder } from '../../../components/UI/VoiceRecorder/VoiceRecorder';
import { IDocumentInput } from '../../../store/slices/documents';
import { SalesOrderInfo } from '../../../store/slices/salesOrders';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  selectedSalesOrder?: SalesOrderInfo;
  isOpen: boolean;
  onClose: () => void;
  handleSave: (document: IDocumentInput) => void;
};

const VoiceRecorderModal: React.FC<Props> = ({
  selectedSalesOrder,
  isOpen,
  onClose,
  handleSave,
}) => {
  const { translations } = useTranslation();
  const [documentTitle, setDocumentTitle] = useState<string>('');
  const [documentComments, setDocumentComments] = useState<string>('');

  return (
    <Modal
      header={translations('voice.recording') ?? ''}
      containerPadding="30px"
      width="85%"
      maxWidth="450px"
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className={classes.container}>
        <div className={classes.recorderContainer}>
          <VoiceRecorder
            handleSave={handleSave}
            documentTitle={documentTitle}
            setDocumentTitle={setDocumentTitle}
            documentComments={documentComments}
            setDocumentComments={setDocumentComments}
          />
        </div>
      </div>
    </Modal>
  );
};

export { VoiceRecorderModal };
